import type { TriggerSearchCounterActionType } from 'redux/triggerSearchCounterActionType';

export function updateTriggerSearchCounter(triggerSearchCounter: number): {
  type: TriggerSearchCounterActionType;
  payload: number;
} {
  return { type: 'UPDATE_TRIGGER_SEARCH_COUNTER', payload: triggerSearchCounter };
}
